export default __webpack_public_path__ + "static/media/ig.f4b64e4e.svg";